import ExtendPositionsInstructionsModalView from "./ExtendPositionsInstructionsModal.html";


angular.module("groups")

    .controller("ExtendPositionsModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'group_id', '$http', 'treeService', '$uibModal', 'gridService', '$q', '$interval', '$timeout', 'uiGridConstants', 'logService',
        function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, group_id, $http, treeService, $uibModal, gridService, $q, $interval, $timeout, uiGridConstants, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.selectedRows = [];
        $scope.origin_group = group_id;
        $scope.destiny_group = 0;

        $scope.getGroupsSearch = function (val) {
            return Restangular.all('search/group/' + val).getList().then(function (searchTerms) {
                return searchTerms;
            });
        };

        $scope.groupSelected = function ($item, $model, $label) {
            $scope.destiny_group = $item.id;
        };

        $scope.saveExtendPosition = function (item) {
            let ids = [];
            $scope.gridOptionsPersonPosition.gridApi.selection.getSelectedRows().forEach(elm => ids.push(elm.id));
            var params = { new_group_name: item.name, origin_group_id: $scope.origin_group, destiny_group_id: $scope.destiny_group, group_date: item.date, person_positions: ids.toString() };
            Restangular.all('Groups').customPOST({}, "ExtendPositions", params).then(function (result) {
                $uibModalInstance.close(result);
            });
        };

        // Modal con las instrucciones 
        $scope.gridOptionsPersonPosition = {
            pdfTitle: $filter('translate')('persons.addresses'),
            enablePaginationControls: true,
            paginationPageSizes: [5, 10, 15],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
                this.gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);
                this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'person_name', field: 'FK_persons_positions_persons.fullname', displayName: $filter('translate')('persons.name'), enableFiltering: true },
                { name: 'position_name', field: 'FK_persons_positions_positions.FK_positions_tl_positions[0].name', displayName: $filter('translate')('positions.name'), enableFiltering: true },
            ],
            getData: function (options) {
                var deferred = $q.defer();
                options.group_id = $scope.origin_group;
                Restangular.all('PersonsPositions').customGET("GetPersonsPositionsByGroup", options).then(function (results) {
                    if (results) {
                        var data = results.rows;
                        data.totalRows = results.totalRows;
                        $scope.totalRows = results.totalRows;
                        deferred.resolve(data);
                    }
                })

                return deferred.promise;
            }
        };

        let callbackFunctionRowSelected = function (row, evt) {
            let addAll = row.length > 1;
            if (!addAll) {
                //buscamos si ya existe la persona añadida
                var index = $scope.selectedRows.map(function (e) { return e; }).indexOf(row.entity.id);
                if (index < 0) {
                    if (row.isSelected) {
                        $scope.selectedRows.push(row.entity.id);
                    } else {
                        $scope.selectedRows.splice(index, 1);
                    }
                } else {
                    if (!row.isSelected) $scope.selectedRows.splice(index, 1);
                }
            } else {
                if (row[0].isSelected) {
                    //se ha seleccionado todo.
                    $scope.selectedRows = [];
                    for (let i = 0; i < $scope.gridOptionsPersonPosition.gridApi.grid.options.totalItems; i++) { $scope.selectedRows.push(i); };
                } else {
                    $scope.selectedRows = [];
                }
            }
            logService.debug($scope.selectedRows);
        }

        let callbackFunctionItemChange = function () {
            $timeout(function () {
                for (var i = 0; i < $scope.gridOptionsPersonPosition.data.length; i++) {
                    var row = $scope.gridOptionsPersonPosition.data[i];
                    for (var select = 0; select < $scope.selectedRows.length; select++) {
                        let selected = $scope.selectedRows[select];
                        if (row.id == selected) {
                            $scope.gridOptionsPersonPosition.gridApi.selection.toggleRowSelection(row);
                            break
                        }
                    };
                }
            }, 350);
        }

        $scope.openInstructions = function () {
              let modalInstance = $uibModal.open({
                template: ExtendPositionsInstructionsModalView,
                controller: "ExtendPositionsInstructionsModalCtrl",
                size: "lg",
                scope: $scope,
                resolve: function () {

                }
            });

        };

    }])
    .controller("ExtendPositionsInstructionsModalCtrl", ['$scope', '$uibModal', '$uibModalInstance', function ($scope, $uibModal, $uibModalInstance) {

        $scope.onClose = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
;